
import type { PropType } from 'vue'

import type {
    ClusterFeatureEntity,
    DispatcherWorkplaceDelivery,
    DispatcherWorkplaceRecordWaitListStatus,
    DispatcherWorkplaceTake
} from '@/modules/DispatcherWorkplaceModule/types'

import type { ClusterFeature } from '@/modules/YandexMap3Module/map-cluster.types'

import { defineComponent, computed } from 'vue'

import DwBadge from '@/modules/DispatcherWorkplaceModule/ui/DwBadge/index.vue'
import DwWaitListStatus from '@/modules/DispatcherWorkplaceModule/components/DwWaitListStatus/index.vue'
import DwActionSequenceIcon from '@/modules/DispatcherWorkplaceModule/components/DwActionSequenceIcon/index.vue'

import {
    DELIVERY_MARKER_COLOR,
    UNDELIVERED_DELIVERY_MARKER_COLOR,
    TAKE_MARKER_COLOR,
    UNASSIGNED_TAKE_MARKER_COLOR,
    PROBLEM_MARKER_COLOR,
} from '@/modules/DispatcherWorkplaceModule/constants'

export default defineComponent({
    components: {
        DwBadge,
        DwWaitListStatus,
        DwActionSequenceIcon
    },
    props: {
        feature: {
            type: Object as PropType<ClusterFeature<ClusterFeatureEntity>>,
            required: true
        },
        isCourierItem: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {
        const featureEntity = computed(() => {
            if (props.feature.entity) {
                return props.feature.entity
            }

            return null
        })

        const isFeatureCompleted = computed(() => {
            if (props.feature.entity) {
                if (props.feature.entity.type === 1) {
                    const takeEntity = props.feature.entity as DispatcherWorkplaceTake
                    return takeEntity.state === 1 || takeEntity.statusId === 3
                }

                if (props.feature.entity.type === 2) {
                    const deliveryEntity = props.feature.entity as DispatcherWorkplaceDelivery
                    return deliveryEntity.state === 1
                }
            }

            return false
        })

        const featureLocation = computed(() => {
            if (props.feature.location) {
                return props.feature.location
            }

            return null
        })

        const computedColor = computed(() => {
            if (props.feature.entity) {
                if (props.feature.entity.type === 1) {
                    if ((props.feature.entity as DispatcherWorkplaceTake).notAssigned) {
                        return UNASSIGNED_TAKE_MARKER_COLOR
                    }
                    
                    return TAKE_MARKER_COLOR
                }

                if (props.feature.entity.type === 2) {
                    if ((props.feature.entity as DispatcherWorkplaceDelivery).notDelivered) {
                        return UNDELIVERED_DELIVERY_MARKER_COLOR
                    }

                    return DELIVERY_MARKER_COLOR
                }
            }

            if (props.feature.location) {
                return PROBLEM_MARKER_COLOR
            }

            return 'black'
        })

        return {
            featureEntity,
            isFeatureCompleted,
            featureLocation,
            computedColor
        }
    }
})
